const initialData = {
  customerRLookUpId: 91,
  sellFactorRLookUpId: 96,
}
const sendData = {

  mode: "add", // edit
  date: "",
  id: "",

  customerId: "", // from RlookUp
  customerName: "", // from RlookUp
  description: "", // max 200 charachters
  factorId: "", // Null or Some Data

  tableData: [
    // {
    //   recordId: "",
    //   particleFactorId: "", // کد فاکتور فروش جز
    //   inventoryId: "", // کد موجودی
    //   storeId: "", // خودم مقدار دهی میکنم
    //   storeName: "",
    //   productId: "",
    //   productName: "",
    //   productGroup: "",
    //   productSize: "",
    //   productColor: "",
    //   price: "",
    //   number: "",
    //   total: "",
    // },
  ]
};
const componentData = {
  currentStoreId: "",
  currentStoreName: "",
  destinationStoreId: "",
  destinationStoreName: "",
}
export const SaleReturnData = {
  sendData,
  componentData,
  initialData,

}